export default "__VITE_ASSET__Mo7pqIeB__"